export const OPERATING_HOURS = {
  '06:00-22:00': { open: '06:00', close: '22:00', label: '06:00 - 22:00' },
  '06:00-23:00': { open: '06:00', close: '23:00', label: '06:00 - 23:00' }
} as const;

export type OperatingHourKey = keyof typeof OPERATING_HOURS;
export type OperatingHourValue = (typeof OPERATING_HOURS)[OperatingHourKey];

export const OPERATING_HOURS_LOV = Object.entries(OPERATING_HOURS).map(([value, data]) => ({
  value,
  label: data.label
}));

export function toOperatingHoursPolicy(key: OperatingHourKey): { open: string; close: string } | null {
  const operatingHours = OPERATING_HOURS[key];
  return operatingHours ? { open: operatingHours.open, close: operatingHours.close } : null;
}

export function fromOperatingHoursPolicy(
  policy: { open: string; close: string } | null | undefined
): OperatingHourKey | null {
  const key = (Object.keys(OPERATING_HOURS) as OperatingHourKey[]).find(
    candidate =>
      OPERATING_HOURS[candidate].open === policy?.open && OPERATING_HOURS[candidate].close === policy?.close
  );
  return key ?? null;
}
